import { on } from "delegated-events";

export default {
  init: () => {
    on(
      "mouseenter",
      "[class*=btn-arrow], .group:has([class*=btn-arrow])",
      (e) => {
        if (e.currentTarget.querySelector(".svg-arrow-right path")) {
          e.currentTarget
            .querySelectorAll(".svg-arrow-right path")
            .forEach((el) => el.dispatchEvent(new Event("mouseover")));
        }
      },
      { capture: true },
    );

    on(
      "mouseleave",
      "[class*=btn-arrow], .group:has([class*=btn-arrow])",
      (e) => {
        if (e.currentTarget.querySelector(".svg-arrow-right path")) {
          e.currentTarget
            .querySelectorAll(".svg-arrow-right path")
            .forEach((el) => el.dispatchEvent(new Event("mouseout")));
        }
      },
      { capture: true },
    );
  },
};
